module.exports = __webpack_public_path__ + "img/LTS_KPMG.9ea0c705.gif";